import React from 'react'
import UpdateDepartmentForm from '../../../component/form/master/department/UpdateDepartmentForm'

export default function UpdateDepartment() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdateDepartmentForm />
                    </div>
                </div>
            </div>
        </>
    )
}
